@if (item()) {
<div class="item">
    <!-- container for template of content, to allow the selected-info-item to render a template provided by the parent, preceding the name (content) at the far left of the component -->
    <ng-container *ngTemplateOutlet="precedingContentTemplateRef() || null"></ng-container>
    <!-- container for template of content, to allow the selected-info-item to render a template provided by the parent as main content -->
    <ng-container *ngTemplateOutlet="contentTemplateRef() || null"></ng-container>
    @if(!contentTemplateRef()) {
    <span class="item__label">{{ item().name }}</span>
    }
    <!-- container for template of content to allow the selected-info-item to render a template provided by the parent, next to the right of the name (base content) in the main area of the component -->
    <ng-container *ngTemplateOutlet="augmentedContentTemplateRef() || null"></ng-container>
    <section class="item__buttons">
        @if (editButton()) {
        <button pButton pRipple type="button" icon="pi pi-pencil" class="p-button-text p-button-lg"
            [pTooltip]="tooltipContent" tooltipPosition="top" (click)="edit.emit('')"></button>
        }
        <button pButton pRipple type="button" icon="pi pi-times-circle"
            class="delete p-button-rounded p-button-text p-button-lg" (click)="delete.emit('')"></button>
    </section>
</div>
}
<ng-template #tooltipContent>
    <div>{{ editButtonToolTip() }}</div>
</ng-template>